/**
 * toastFlowError – calm, non-red toast for non-destructive flow failures.
 *
 * Use this instead of variant='destructive' when the failure is a flow
 * error (e.g. order creation failed, validation rejected by server).
 * Reserve destructive (red) toasts for irreversible user actions.
 */

import { toast } from '@/hooks/use-toast';

export function toastFlowError(
  title: string,
  description?: string,
) {
  toast({
    title,
    description: description ?? 'Försök igen om en liten stund.',
    // variant default = neutral styling, not red
  });
}
